
import React, { useState } from "react";
import { Button, Col, Form, Modal } from "react-bootstrap";
import { useForm } from "react-hook-form";
import { useAddRefundMutation } from "../../../store/services/refundService";
import toast from "react-hot-toast";
import styles from "./MealsPop.module.scss";

const RefundRejectPop = ({ title, modalOpenRej, setModalOpenRej, edit }) => {
  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm({
    mode: "onTouched",
    defaultValues: {
      amount: edit?.amount || "",
      reason: edit?.reason || "",
    },
  });

  const [addRefund, { isLoading }] = useAddRefundMutation();

  const onSubmit = async (data) => {
    try {
      const payload = {
        transactionId: edit?.transactionId, // Pass the transactionId from edit
        //amount: Number(data.amount),
        //reason: data.reason,
        status: "rejected",
      };

      await addRefund(payload).unwrap();
      toast.success("Refund rejected successfully");
      setModalOpenRej(false);
    } catch (error) {
      console.error("Failed to process refund:", error);
      toast.error("Failed to process refund");
    }
  };

  return (
    <Modal
      show={modalOpenRej}
      className={`${styles.MealsPop} transparentModal`}
      onHide={() => setModalOpenRej(false)}
      backdrop={true}
      keyboard={false}
      centered
    >
      <Modal.Body className={styles.modalBody}>
        <h3 className="m-0 fw-bold themeBlue text-center">{title}</h3>
        <Form onSubmit={handleSubmit(onSubmit)}>
          {/* <Col lg="12" className="my-2">
            <div className="py-2">
              <label className="form-label fw-sbold text-muted">Amount</label>
              <input
                type="number"
                placeholder="Enter amount"
                className="form-control"
                {...register("amount", { required: "Please enter amount", min: 1 })}
              />
              {errors.amount && <span className="text-danger">{errors.amount.message}</span>}
            </div>

            <div className="py-2">
              <label className="form-label fw-sbold text-muted">Reason</label>
              <input
                type="text"
                placeholder="Enter reason"
                className="form-control"
                {...register("reason", {
                  required: "Please enter reason",
                  validate: (value) => !/^\s/.test(value) || "Reason cannot start with a space",
                })}
              />
              {errors.reason && <span className="text-danger">{errors.reason.message}</span>}
            </div>
          </Col> */}

          <Col lg="12" className="my-2 d-flex justify-content-center gap-2">
            <Button className="commonBtn" type="submit" disabled={isLoading}>
              Submit
            </Button>
            <Button className="commonBtn GreyBtn" type="button" onClick={() => setModalOpenRej(false)}>
              Cancel
            </Button>
          </Col>
        </Form>
      </Modal.Body>
    </Modal>
  );
};

export default RefundRejectPop;




















